import { render, staticRenderFns } from "./userProfile.vue?vue&type=template&id=586197a8&scoped=true"
import script from "./userProfile.vue?vue&type=script&lang=js"
export * from "./userProfile.vue?vue&type=script&lang=js"
import style0 from "./userProfile.vue?vue&type=style&index=0&id=586197a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586197a8",
  null
  
)

export default component.exports